// styles
import styles from '../detail.module.scss';

// types
import type { EventLocatorItem } from 'components/ContentElementsGdds/locator/showroom/sidebar';

// components
import { InnerHtml } from 'components/InnerHtml/inner-html';
import { Translation } from 'components/Translation/Translation';
import { ExternalLink } from 'components/Link/ExternalLink';

// utils
import { externalLinkProps, DATE_FORMAT, TIME_FORMAT } from 'components/ContentElementsGdds/locator/showroom';
import { validateDate } from 'utils/validateDate';
import { decodingContent } from 'utils/decodingContent';
import { useTranslationFunction } from 'utils/hooks/use-translations';
import { isEmpty } from 'utils/is-empty';

type EventDetailProps = {
  item: EventLocatorItem;
  openAcc: boolean;
  isAcc: boolean;
};

export function EventDetail({
  item: {
    lat,
    lng,
    address1,
    address2,
    date,
    time,
    description_title: descriptionTitle,
    description,
  },
  openAcc,
  isAcc,
}: Readonly<EventDetailProps>) {
  const openClass = openAcc ? styles.open : styles.closed;
  const translate = useTranslationFunction();

  const setWrapper = (children) => {
    if (isAcc) {
      return (
        <div className={openClass}>
          <div className={styles.sidebarAccWrapper}>{children}</div>
        </div>
      );
    }

    return children;
  };

  const createdDate = date && validateDate(new Date(date), DATE_FORMAT);
  const createdTime = date && time && validateDate(new Date(`${date} ${time}`), TIME_FORMAT);

  return setWrapper(
    <>
      <div className={styles.locatorDetail}>
        <ul>
          <InnerHtml as="li" content={address1} />
          <InnerHtml as="li" content={address2} />
        </ul>
        <ul>
          {createdDate && (
            <li>
              <b>
                <Translation id="web20_locator_date" />:
              </b>
              {decodingContent(createdDate)}
            </li>
          )}
          {createdTime && (
            <li>
              <b>
                <Translation id="web20_locator_time" />:
              </b>
              {decodingContent(createdTime)}
            </li>
          )}
        </ul>
        {!isEmpty(descriptionTitle) ||
          (!isEmpty(description) && (
            <ul>
              {!isEmpty(descriptionTitle) && (
                <li>
                  <InnerHtml as="b" content={descriptionTitle} />
                </li>
              )}
              {!isEmpty(description) && (
                <li>
                  <InnerHtml as="span" content={description} />
                </li>
              )}
            </ul>
          ))}
      </div>
      <p>
        <ExternalLink
          content={{
            ...externalLinkProps,
            target: `http://www.google.com/maps/place/${lat},${lng}`,
            text: translate('web20_locator_route'),
            showArrow: true,
          }}
          pure
        />
      </p>
    </>,
  );
}
